export enum LocalTableConfigType {
  ASK_YOUR_ALERT_TXN_EVENTS_TABLE = 'ASK_YOUR_ALERT_TXN_EVENTS_TABLE',
  ASK_YOUR_ALERT_ACTION_EVENTS_TABLE = 'ASK_YOUR_ALERT_ACTION_EVENTS_TABLE',
  ASK_YOUR_ALERT_ENTITIES_TABLE = 'ASK_YOUR_ALERT_ENTITIES_TABLE',
  ASK_YOUR_ALERT_INSTRUMENTS_TABLE = 'ASK_YOUR_ALERT_INSTRUMENTS_TABLE',
}

export interface ColumnMetadata {
  key: string;
  label: string;
  description?: string;
}

export interface LocalColumnConfig extends ColumnMetadata {
  hidden: boolean;
}

export type LocalTableConfigState = Partial<
  Record<LocalTableConfigType, LocalColumnConfig[]>
>;

export interface LocalTableConfigActionPayload {
  coordinates: { x: number; y: number };
  tableConfigType: LocalTableConfigType;
}
